const BADGES = [
  { sym: "GH₵", flag: "gh", name: "Ghana", ang: -157.5 },
  { sym: "₦", flag: "ng", name: "Nigeria", ang: -112.5 },
  { sym: "TSh", flag: "tz", name: "Tanzania", ang: -67.5 },
  { sym: "R", flag: "za", name: "South Africa", ang: -22.5 },
  { sym: "KSh", flag: "ke", name: "Kenya", ang: 22.5 },
  { sym: "E£", flag: "eg", name: "Egypt", ang: 67.5 },
  { sym: "€", flag: "eu", name: "Europe", ang: 112.5 },
  { sym: "$", flag: "us", name: "United States", ang: 157.5 },
];

const RING_R = 42;
const BADGE_R = 47.5;

const pos = (ang, rad) => ({
  left: `${50 + rad * Math.cos((ang * Math.PI) / 180)}%`,
  top: `${50 - rad * Math.sin((ang * Math.PI) / 180)}%`,
});

const GlobeHero = () => (
  <div className="relative aspect-square w-[430px] max-w-none sm:w-[540px] lg:w-[700px]" data-testid="globe-hero">
    {/* static globe — Africa in focus */}
    <img
      src="/globe-hero.png"
      alt="Dotted globe with Africa in focus"
      className="absolute inset-[6%] h-[88%] w-[88%] opacity-60 lg:opacity-80"
    />
    {/* rotating ring with nodes + outer badges */}
    <div className="sw-spin-slow absolute inset-0">
      <svg className="absolute inset-0 h-full w-full" viewBox="0 0 100 100" fill="none" aria-hidden="true">
        <circle cx="50" cy="50" r={RING_R} stroke="#2E7CD6" strokeOpacity="0.4" strokeWidth="0.6" />
      </svg>
      {/* nodes on the ring at each badge position */}
      {BADGES.map((b) => (
        <span
          key={`node-${b.sym}`}
          data-testid={`node-${b.flag}`}
          className="absolute h-2 w-2 rounded-full bg-[#2E7CD6] shadow-[0_0_0_3px_rgba(46,124,214,0.18)]"
          style={{ ...pos(b.ang, RING_R), transform: "translate(-50%, -50%)" }}
        />
      ))}
      {/* badges outside the ring, equidistant, always upright — centered via outer translate so the counter-spin origin is the badge center */}
      {BADGES.map((b) => (
        <div
          key={b.sym}
          data-testid={`badge-${b.flag}`}
          className="absolute"
          style={{ ...pos(b.ang, BADGE_R), transform: "translate(-50%, -50%)" }}
        >
          <div className="sw-spin-slow-rev flex items-center gap-1.5">
            <img
              src={`https://flagcdn.com/w80/${b.flag}.png`}
              alt={`${b.name} flag`}
              loading="lazy"
              style={{ width: 24, height: 16 }}
              className="shrink-0 rounded-[3px] object-cover shadow-sm"
            />
            <span className={`font-heading text-xs font-bold sm:text-sm ${b.sym === "$" || b.sym === "€" ? "text-[#64748B]" : "text-[#1E3A6E]"}`}>
              {b.sym}
            </span>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default GlobeHero;
